<template>
  <div id="statisticsView">
    <statistics-controller></statistics-controller>
    <statistics-container></statistics-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import StatisticsController from '../components/Statistics/StatisticsController.vue';
import StatisticsContainer from '../components/Statistics/StatisticsContainer.vue';

export default {
  mounted() {
    this.fetchAuthorities();
    this.fetchYears();
  },
  components: {
    StatisticsController,
    StatisticsContainer,
  },
  methods: {
    ...mapActions(['fetchAuthorities', 'fetchYears']),
  },
};
</script>

<style lang="scss" scoped>
#statisticsView {
  display:flex;
  flex-direction:column;
  height:100%;
}
</style>
